import React, { useContext } from "react";
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { colors } from "@mui/material";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");
  // console.log(user,"running")

  // language
  const translations = {
    hi: {
      view: "देखे",
      prize: "इनाम",
      entry: "प्रवेश शुल्क",
    },
    en: {
      view: "view",
      entry: "Entry Fee ",
      prize: "Winning Prize",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem("theme");

  const styles = {
    color: theme === "light" ? "black" : "black",
  };

  return (
    <>
      <div className="battle-card-premium">
        {/* Top Header: Players Info */}
        <div className="battle-header-section">
          <div className="player-badge-container">
            <span className="playing-for-label">Playing For:</span>
            <div className="players-vs-wrapper">
              <span className="player-name creator-color">
                {runnig.Created_by.Name.length > 5
                  ? `${runnig.Created_by.Name.slice(0, 5)}...`
                  : runnig.Created_by.Name}
              </span>
              <span className="vs-divider">&</span>
              <span className="player-name acceptor-color">
                {runnig.Accepetd_By.Name.length > 5
                  ? `${runnig.Accepetd_By.Name.slice(0, 5)}....`
                  : runnig.Accepetd_By.Name}
              </span>
            </div>
          </div>
        </div>

        {/* Middle Section: Stats & Action */}
        <div className="battle-stats-container">
          {/* Entry Box */}
          <div className="stat-box entry-side">
            <p className="stat-title">{translations[language].entry}</p>
            <div className="amount-row">
              <img src="/images/moneyrupee.png" alt="₹" className="coin-icon" />
              <span className="amount-text">{runnig.Game_Ammount}</span>
            </div>
          </div>

          {/* Center Action (View Button or VS Icon) */}
          <div className="stat-center-action">
            {user == runnig.Accepetd_By._id || user == runnig.Created_by._id ? (
              <Link
                className={`view-game-btn ${runnig.Status === "conflict" ? "status-conflict" : "status-success"}`}
                to={{
                  pathname: `/viewgame1/${runnig._id}`,
                  state: { prevPath: window.location.pathname },
                }}
              >
                {translations[language].view}
              </Link>
            ) : (
              <div className="vs-icon-box">
                <img
                  src={process.env.PUBLIC_URL + "/images/Homepage/versus.png"}
                  alt="VS"
                  className="vs-img-fluid"
                />
              </div>
            )}
          </div>

          {/* Prize Box */}
          <div className="stat-box prize-side">
            <p className="stat-title">{translations[language].prize}</p>
            <div className="amount-row">
              <img src="/images/moneyrupee.png" alt="₹" className="coin-icon" />
              <span className="amount-text highlight-prize">
                {runnig.Game_Ammount + winnAmount(runnig.Game_Ammount)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
